import { Group, Select, Text } from '@mantine/core';

import ColorSwatch from '@/components/ColorSwatch';
import { COLOR_SCHEMES } from '@/lib/colorSchemes';
import { useChartStore } from '@/store/chartStore';

const COLOR_SCHEME_OPTIONS = [
  {
    group: 'Type-Based',
    items: [{ value: 'TYPE_BASED_DEFAULT', label: 'Pairs/Suited/Offsuit' }],
  },
  {
    group: 'Heatmaps',
    items: [
      { value: 'HEATMAP_RED_GREEN', label: 'Red to Green' },
      { value: 'HEATMAP_BLUE_RED', label: 'Blue to Red' },
      { value: 'HEATMAP_VIRIDIS', label: 'Viridis' },
      { value: 'HEATMAP_PASTEL', label: 'Pastel' },
    ],
  },
  {
    group: 'GTO',
    items: [{ value: 'GTO_ACTIONS', label: 'Poker Actions' }],
  },
  {
    group: 'Categorical',
    items: [
      { value: 'CATEGORICAL_2', label: '2 categories' },
      { value: 'CATEGORICAL_3', label: '3 categories' },
      { value: 'CATEGORICAL_4', label: '4 categories' },
      { value: 'CATEGORICAL_5', label: '5 categories' },
      { value: 'CATEGORICAL_6', label: '6 categories' },
      { value: 'CATEGORICAL_7', label: '7 categories' },
      { value: 'CATEGORICAL_8', label: '8 categories' },
    ],
  },
];

export default function ColorSchemeSelector() {
  const config = useChartStore((state) => state.config);
  const setColorScheme = useChartStore((state) => state.setColorScheme);

  // Find the current scheme key
  const currentSchemeKey =
    Object.entries(COLOR_SCHEMES).find(([_, scheme]) => scheme === config.colorScheme)?.[0] || 'TYPE_BASED_DEFAULT';

  const handleChange = (value: string | null) => {
    if (!value) return;
    const schemeId = value as keyof typeof COLOR_SCHEMES;
    const scheme = COLOR_SCHEMES[schemeId];
    if (scheme) {
      setColorScheme(scheme, schemeId);
    }
  };

  return (
    <Select
      label="Color Scheme"
      description="Choose how to color the hand chart"
      data={COLOR_SCHEME_OPTIONS}
      value={currentSchemeKey}
      onChange={handleChange}
      w={250}
      leftSection={<ColorSwatch schemeKey={currentSchemeKey as keyof typeof COLOR_SCHEMES} />}
      renderOption={({ option }) => (
        <Group gap="sm" wrap="nowrap">
          <ColorSwatch schemeKey={option.value as keyof typeof COLOR_SCHEMES} />
          <Text size="sm">{option.label}</Text>
        </Group>
      )}
    />
  );
}
